import { render, staticRenderFns } from "./AddMailingListDialog.vue?vue&type=template&id=b4bc441a&scoped=true"
import script from "./AddMailingListDialog.ts?vue&type=script&lang=js&external"
export * from "./AddMailingListDialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc441a",
  null
  
)

export default component.exports